import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { createStore } from 'vuex'
import { storeOpts } from '@/store'

export let store = createStore(storeOpts);

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        redirect: "/login",
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index.vue'),
        meta: { title: '登录', content: 'disable-no' },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页总览', content: 'disable-no' },
    },
    // {
    //     path: '/monitor',
    //     name: 'monitor',
    //     component: () => import('@/views/monitor/index.vue'),
    //     meta: { title: '视频监控', content: 'disable-no' },
    // },
    {
        path: '/device',
        name: 'device',
        component: () => import('@/views/device/index.vue'),
        meta: { title: '设备管理', content: 'disable-no' },
    },
    {
        path: '/record',
        name: 'record',
        component: () => import('@/views/record/index.vue'),
        meta: { title: '历史记录', content: 'disable-no' },
    },
    {
        path: '/graph',
        name: 'graph',
        component: () => import('@/views/graph/index.vue'),
        meta: { title: '图形监控', content: 'disable-no' },
    },
    {
        path: '/user',
        name: 'user',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户管理', content: 'disable-no' },
    },
    {
        path: '/protocol',
        name: 'protocol',
        component: () => import('@/views/protocol/index.vue'),
        meta: { title: '报文监控', content: 'disable-no' },
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem('token')
    if (to.path === '/login') {
        next()
    } else {
        if (token) {
            next()
        } else {
            next('/login')
        }
    }
})

export default router
